import React from "react";
import CustomTable from "../helpers/customtable";
import formatPrice from "../helpers/formatPrice";
import "../../css/WorkAnalyzerTables.css";

const baseConfig = (t, rowKey, emptyKey) => ({
  rowKey,
  emptyText: t(emptyKey),
  pageSize: 10,
  labels: { filter: t("filter"), search: t("search"), actions: t("actions") }
});
const column = (t, key, label, width, align = "left") => ({
  key,
  header: t(label),
  width,
  align,
  default: t("none")
});

export function WorkMaterialsTable({ groups, t }) {
  const rows = groups.map((group) => ({
    ...group,
    rowId: JSON.stringify([group.colorId, group.millingId]),
    quantityLabel: `${group.quantity} ${group.isMdf ? "m²" : t("quantityShort")}`,
    totalPriceLabel: `${formatPrice(group.totalPrice)} RON`,
    unitPriceLabel: `${formatPrice(group.pricePerQty)} RON`
  }));
  const config = {
    ...baseConfig(t, "rowId", "workMaterialsEmpty"),
    columns: [
      column(t, "color", "color", "24%"),
      column(t, "milling", "milling", "18%"),
      {
        ...column(t, "quantityLabel", "ammount", "15%", "right"),
        shortHeader: t("workQuantityShort"),
        sortValue: (row) => Number(row.quantity)
      },
      {
        ...column(t, "totalPriceLabel", "totalPrice", "23%", "right"),
        shortHeader: t("worksHeaderShort_totalPrice"),
        sortValue: (row) => Number(row.totalPrice)
      },
      {
        ...column(t, "unitPriceLabel", "unitPrice", "23%", "right"),
        sortValue: (row) => Number(row.pricePerQty)
      }
    ]
  };
  return (
    <div className="work-analyzer-table">
      <CustomTable data={rows} config={config} />
    </div>
  );
}

export function WorkFilesTable({
  files,
  t,
  formatFileSize,
  isImageFile,
  onPreview,
  onDownload,
  onImport,
  onManualImport,
  onDelete
}) {
  const rows = files.map((file) => {
    const timestamp = file.creationDate
      ? new Date(file.creationDate).getTime()
      : NaN;
    return {
      ...file,
      original: file,
      sizeLabel: formatFileSize(file.size),
      dateValue: Number.isNaN(timestamp) ? null : timestamp,
      dateLabel: Number.isNaN(timestamp)
        ? t("none")
        : new Date(timestamp).toLocaleDateString()
    };
  });
  const config = {
    ...baseConfig(t, "fileId", "workFilesEmpty"),
    columns: [
      {
        ...column(t, "fileName", "fileTableName", "48%"),
        truncate: { mode: "middle", tailLength: 6 }
      },
      {
        ...column(t, "sizeLabel", "fileTableSize", "17%", "right"),
        sortValue: (row) => Number(row.size)
      },
      {
        ...column(t, "dateLabel", "fileTableDate", "23%"),
        sortValue: (row) => row.dateValue
      },
      {
        key: "actions",
        width: "12%",
        text: "...",
        appearOnHover: false,
        actionlist: [
          {
            key: "preview",
            label: t("fileMenuPreview"),
            icon: "bi-eye",
            onClick: (row) => onPreview(row.original)
          },
          {
            key: "download",
            label: t("fileMenuDownload"),
            icon: "bi-download",
            onClick: (row) => onDownload(row.original)
          },
          {
            key: "import",
            label: t("fileMenuImport"),
            icon: "bi-cloud-upload",
            onClick: (row) => onImport(row.original)
          },
          {
            key: "manualImport",
            label: t("fileMenuManualImport"),
            icon: "bi-pencil",
            visible: (row) => isImageFile(row.fileName),
            onClick: (row) => onManualImport(row.original)
          },
          {
            key: "delete",
            label: t("fileMenuDelete"),
            icon: "bi-trash",
            onClick: (row) => onDelete(row.fileId)
          }
        ]
      }
    ],
    onRowClick: (row) => onPreview(row.original)
  };
  return (
    <div className="work-analyzer-table">
      <CustomTable data={rows} config={config} />
    </div>
  );
}
